import { normalizeTournamentData } from '@sportal365/smp-widget-normalizers';
import { IFootballConfig, INormalizedTournamentData, ITournament } from '../../../../packages/types';

interface INormalizeFootballCompetitionResponseDataArgs {
  competition?: ITournament;
  dataEntityLinks?: IFootballConfig['dataEntityLinks'];
}

export const normalizeFootballCompetitionResponseData = ({
  competition,
  dataEntityLinks,
}: INormalizeFootballCompetitionResponseDataArgs): INormalizedTournamentData | undefined => {
  const normalizedCompetition = normalizeTournamentData({ tournament: competition, dataEntityLinks });

  return normalizedCompetition;
};
